/**
* FUNMED – IDENTITETSKONTROLL I VARUKORGEN
* ---------------------------------------------------------------------------
* Syfte: säkerställa att varje webborder bär EN otvetydig identitet för den
* som ska ta provet, i ett enda format, även när någon köper åt någon annan.
*
* Ersätter den tidigare "__pnCheckoutGuard".
*
* Sätter följande orderattribut:
*   Personnummer          – alltid 12 siffror utan bindestreck (ÅÅÅÅMMDDNNNN)
*   Provet avser          – "Mig själv" eller "Någon annan". Inget förval sedan
*                           1/10 2026: kunden måste välja aktivt.
*   Patient namn          – endast när provet avser någon annan
*   Patient e-post        – endast när provet avser någon annan
*   Patient mobil         – endast när provet avser någon annan
*
* Peter: allt som är tänkt att kunna justeras ligger i INSTALLNINGAR nedan.
**/

(function () {
  if (window.__fmIdentitetsvakt) return;
  window.__fmIdentitetsvakt = true;

  /* ======================= INSTALLNINGAR ======================= */
  const INSTALLNINGAR = {
    // Kräv e-post till den som ska testa sig när man köper åt någon annan.
    // Sätt till false om det visar sig sänka konverteringen.
    kravEpostTillAnnan: true,

    // Kräv mobilnummer till den som ska testa sig. Av som standard.
    kravMobilTillAnnan: false,

    // Blockera "Köp nu"/Shop Pay/Apple Pay på produktsidan. Dessa hoppar över
    // varukorgen helt och ger order HELT UTAN personnummer.
    blockeraDirektkopPaProduktsida: true,

    // Blockera express-knappar i varukorgen tills personnumret är giltigt.
    blockeraExpressIVarukorgen: true
  };
  /* ============================================================= */

  const NYCKEL = {
    pn: 'attributes[Personnummer]',
    avser: 'attributes[Provet avser]',
    namn: 'attributes[Patient namn]',
    epost: 'attributes[Patient e-post]',
    mobil: 'attributes[Patient mobil]'
  };

  const MIG_SJALV = 'Mig själv';
  const NAGON_ANNAN = 'Någon annan';

  /* ---------------------------------------------------------------
   * 1. PERSONNUMMER – normalisering och validering
   * ------------------------------------------------------------- */

  // Returnerar { ok, varde, fel }.
  // Accepterar 10 eller 12 siffror, med eller utan bindestreck, samt "+"
  // för personer över 100 år. Normaliserar alltid till ÅÅÅÅMMDDNNNN.
  // Validerar datum, rimligt födelseår, samordningsnummer (dag + 60) och
  // Luhn-kontrollsiffran.
  function tolkaPersonnummer(ratext) {
    const text = String(ratext || '').trim();
    if (!text) return { ok: false, fel: 'Ange personnummer.' };

    const overHundra = text.indexOf('+') !== -1;
    const siffror = text.replace(/\D/g, '');
    const iar = new Date().getFullYear();

    let ar, resten;
    if (siffror.length === 12) {
      ar = parseInt(siffror.slice(0, 4), 10);
      resten = siffror.slice(4);
    } else if (siffror.length === 10) {
      ar = 2000 + parseInt(siffror.slice(0, 2), 10);
      if (ar > iar) ar -= 100;
      if (overHundra) ar -= 100;
      resten = siffror.slice(2);
    } else {
      return { ok: false, fel: 'Personnumret ska ha 10 eller 12 siffror. Skriv ÅÅÅÅMMDD-XXXX.' };
    }

    const manad = parseInt(resten.slice(0, 2), 10);
    const dagRa = parseInt(resten.slice(2, 4), 10);
    // Samordningsnummer har 60 adderat till dagen.
    const dag = dagRa > 60 ? dagRa - 60 : dagRa;

    if (ar < 1900 || ar > iar) return { ok: false, fel: 'Kontrollera födelseåret i personnumret.' };
    if (manad < 1 || manad > 12) return { ok: false, fel: 'Kontrollera månaden i personnumret.' };
    const dagarIManaden = new Date(ar, manad, 0).getDate();
    if (dag < 1 || dag > dagarIManaden) return { ok: false, fel: 'Kontrollera dagen i personnumret.' };

    // Luhn på de tio betydelsebärande siffrorna.
    const tio = String(ar).slice(2) + resten;
    let summa = 0;
    for (let i = 0; i < 10; i++) {
      let n = parseInt(tio[i], 10);
      if (i % 2 === 0) { n *= 2; if (n > 9) n -= 9; }
      summa += n;
    }
    if (summa % 10 !== 0) {
      return { ok: false, fel: 'Personnumret verkar felskrivet – kontrollera sista siffran.' };
    }

    return { ok: true, varde: String(ar) + resten };
  }

  function giltigEpost(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim());
  }

  function giltigMobil(v) {
    const s = String(v || '').replace(/[\s\-()]/g, '');
    return /^(\+46|0)7\d{8}$/.test(s);
  }

  /* ---------------------------------------------------------------
   * 2. Hjälpare för att läsa/skriva fälten
   * ------------------------------------------------------------- */

  const alla = (namn) => Array.from(document.querySelectorAll('[name="' + namn + '"]'));

  function las(namn) {
    const faltet = alla(namn);
    for (const f of faltet) {
      const v = (f.value || '').trim();
      if (v) return v;
    }
    return '';
  }

  function lasAvser() {
    const vald = document.querySelector('[name="' + NYCKEL.avser + '"]:checked');
    return vald ? vald.value : '';
  }

  // Speglar värdet till alla fält med samma namn (varukorgssidan och lådan
  // renderar båda samma fält – utan detta skrev den tomma över den ifyllda).
  function spegla(namn, varde) {
    alla(namn).forEach((f) => { if (f.value !== varde) f.value = varde; });
  }

  // Samma val i varukorgssidan och lådan, så att det kunden ser är det vi
  // sparar. Att sätta checked utlöser inget change-event, så ingen loop.
  function speglaVal(varde) {
    document
      .querySelectorAll('[name="' + NYCKEL.avser + '"][value="' + varde + '"]')
      .forEach((r) => { if (!r.checked) r.checked = true; });
  }

  /* ---------------------------------------------------------------
   * 3. Injicera "Vem är provet till?" under varje personnummerfält
   * ------------------------------------------------------------- */

  const STIL = `
    .fm-val { margin: 0 0 10px; }
    .fm-val__fraga { font-size: 13px; font-weight: 600; margin: 0 0 6px; }
    .fm-val__knappar { display: flex; gap: 10px; }
    .fm-val__knappar label { flex: 1 1 0; position: relative; display: flex; align-items: center; justify-content: center; min-height: 46px; padding: 8px 12px; border: 1.5px solid #C9D3D2; border-radius: 999px; background: #fff; font-size: 14.5px; font-weight: 600; color: #3F4D54; cursor: pointer; text-align: center; -webkit-tap-highlight-color: transparent; }
    .fm-val__knappar input { position: absolute; opacity: 0; width: 1px; height: 1px; margin: 0; pointer-events: none; }
    .fm-val__knappar label:has(input:checked) { border-color: #007869; background: #007869; color: #fff; }
    .fm-val__knappar label:has(input:focus-visible) { outline: 2px solid #007869; outline-offset: 2px; }
    .fm-identitet__falt { display: none; margin-top: 10px; }
    .fm-identitet__falt.ar-synlig { display: block; }
    .fm-identitet__falt input { width: 100%; margin-bottom: 8px; }
    .cart-attribute__hint.ar-annan { background: #FFF6E5; border-radius: 6px; padding: 8px 10px; color: #6B4E00; }
    .fm-fel { color: #B3261E; font-size: 12.5px; margin: 4px 0 0; }
    .fm-flera { font-size: 12.5px; line-height: 1.5; background: #FFF6E5; color: #6B4E00; border-radius: 6px; padding: 8px 10px; margin: 10px 0 0; }
    .fm-blockerad { opacity: .4; pointer-events: none; filter: grayscale(1); }
    .fm-blockerad-notis { font-size: 12.5px; color: #5C696F; margin: 6px 0 0; text-align: center; }
    .fm-laddar { opacity: .75; pointer-events: none; cursor: wait; }
  `;

  const HJALPTEXT = {
    migSjalv: 'Ange ditt personnummer. Vi behöver det för att skapa remissen hos laboratoriet ' +
              'och koppla provsvaren till rätt person. Uppgiften används inte till något annat.',
    nagonAnnan: 'Fyll i personnumret för den som ska testa sig, inte ditt eget. ' +
                'Provsvaren kopplas till den person personnumret tillhör.'
  };

  function laggInStil() {
    if (document.getElementById('fm-identitet-stil')) return;
    const s = document.createElement('style');
    s.id = 'fm-identitet-stil';
    s.textContent = STIL;
    document.head.appendChild(s);
  }

  let raknare = 0;
  let monterar = false;

  function montera() {
    if (monterar) return;
    monterar = true;
    try { monteraNu(); } finally { monterar = false; }
  }

  function monteraNu() {
    laggInStil();

    alla(NYCKEL.pn).forEach((pnFalt) => {
      const behallare = pnFalt.closest('.cart-attribute') || pnFalt.parentElement;
      if (!behallare || behallare.dataset.fmMonterad) return;
      behallare.dataset.fmMonterad = '1';

      const suffix = 'fm' + (++raknare);
      const etikett = behallare.querySelector('label') || pnFalt;

      // Temats egen felruta är alltid dold och saknar logik. Bort med den så
      // att vi bara har ett felmeddelande.
      const gammaltFel = behallare.querySelector('.cart-attribute__error');
      if (gammaltFel) gammaltFel.remove();

      // Frågan ligger FÖRE personnummerfältet, eftersom svaret avgör vems
      // personnummer som ska fyllas i.
      // Inget förval (1/10 2026). Ett förvalt "Mig själv" lät kunden skriva in
      // någon annans personnummer utan att byta val, och ordern gick ut i
      // köparens namn. Nu måste valet göras aktivt, se kontrollera().
      const val = document.createElement('div');
      val.className = 'fm-val';
      val.innerHTML =
        '<p class="fm-val__fraga">Vem är provet till?</p>' +
        '<div class="fm-val__knappar">' +
        '<label><input type="radio" name="' + NYCKEL.avser + '" value="' + MIG_SJALV + '"><span>Mig själv</span></label>' +
        '<label><input type="radio" name="' + NYCKEL.avser + '" value="' + NAGON_ANNAN + '"><span>Någon annan</span></label>' +
        '</div>';
      behallare.insertBefore(val, etikett);

      // Fälten hamnar direkt under temats hjälptext, som vi i stället skriver om
      // beroende på valet. Då står samma sak bara på ett ställe.
      const hjalp = behallare.querySelector('.cart-attribute__hint');
      const falt = document.createElement('div');
      falt.className = 'fm-identitet__falt';
      falt.innerHTML =
        '<input type="text"  name="' + NYCKEL.namn + '"  class="input__field" placeholder="För- och efternamn" autocomplete="off">' +
        '<input type="email" name="' + NYCKEL.epost + '" class="input__field" placeholder="E-postadress" autocomplete="off">' +
        '<input type="tel"   name="' + NYCKEL.mobil + '" class="input__field" placeholder="Mobilnummer (valfritt)" autocomplete="off">';
      if (hjalp) hjalp.insertAdjacentElement('afterend', falt);
      else pnFalt.insertAdjacentElement('afterend', falt);

      const fel = document.createElement('p');
      fel.className = 'fm-fel';
      fel.setAttribute('data-fm-fel', suffix);
      fel.style.display = 'none';
      falt.insertAdjacentElement('afterend', fel);

      // Rabattkodsraden hamnade mitt i identitetsblocket. Flytta den sist.
      Array.from(behallare.querySelectorAll('p')).forEach((p) => {
        if (/rabattkod/i.test(p.textContent) && !p.className) behallare.appendChild(p);
      });
    });

    varnaVidFleraProver();
    synkaSynlighet();
    fyllIFranVarukorg();
    hanteraExpressknappar();
  }

  function synkaSynlighet() {
    const arAnnan = lasAvser() === NAGON_ANNAN;

    document.querySelectorAll('.fm-identitet__falt').forEach((b) => {
      b.classList.toggle('ar-synlig', arAnnan);
    });

    // En hjälptext som byter innehåll, i stället för två texter som säger
    // ungefär samma sak under varandra.
    document.querySelectorAll('.cart-attribute__hint').forEach((p) => {
      // Skriv bara när texten faktiskt ändras: textContent byter ut textnoden,
      // vilket MutationObservern längst ned ser som en DOM-ändring. Att alltid
      // skriva gav montera → mutation → montera i all oändlighet (2/9).
      const ny = arAnnan ? HJALPTEXT.nagonAnnan : HJALPTEXT.migSjalv;
      if (p.textContent !== ny) p.textContent = ny;
      p.classList.toggle('ar-annan', arAnnan);
    });

    document.querySelectorAll('[name="' + NYCKEL.mobil + '"]').forEach((f) => {
      f.placeholder = INSTALLNINGAR.kravMobilTillAnnan ? 'Mobilnummer' : 'Mobilnummer (valfritt)';
    });
  }

  /* En hämtning i taget, med kort återanvändning. montera() körs vid varje
     DOM-ändring via observern längst ned, och när varje varv gjorde en egen
     fetch av /cart.js växte anropen till en storm som köade i webbläsarens
     anslutningspool och svalt sajtens alla övriga korganrop (hittat 2/9). */
  let korgLofte = null;
  let korgTid = 0;
  function hamtaKorg() {
    const nu = Date.now();
    if (!korgLofte || nu - korgTid > 800) {
      korgTid = nu;
      korgLofte = fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
    }
    return korgLofte;
  }

  /* Ett personnummer gäller hela ordern. Innehåller varukorgen flera prover
     kan de alltså inte gå till olika personer, och det måste kunden få veta
     innan hon betalar. */
  async function varnaVidFleraProver() {
    const behallare = document.querySelector('[name="' + NYCKEL.pn + '"]');
    if (!behallare) return;
    const rot = behallare.closest('.cart-attribute') || behallare.parentElement;
    if (!rot) return;

    let antal = 0;
    try {
      const varukorg = await hamtaKorg();
      antal = (varukorg.items || []).reduce((s, r) => s + r.quantity, 0);
    } catch (e) { return; }

    const befintlig = rot.querySelector('.fm-flera');
    if (antal > 1 && !befintlig) {
      const p = document.createElement('p');
      p.className = 'fm-flera';
      // Neutral formulering (Peter 5/10): vi uppmanar till flera analyser via
      // mängdrabatten och ska inte varna för samma sak i nästa steg.
      p.textContent = 'Alla analyser i beställningen gäller samma person. '
        + 'Ska de gå till olika personer lägger du en beställning per person.';
      rot.appendChild(p);
    } else if (antal <= 1 && befintlig) {
      befintlig.remove();
    }
  }

  /* ---------------------------------------------------------------
   * 4. Förifyllning – fälten var tidigare alltid tomma efter omladdning,
   *    vilket gjorde att ett redan sparat personnummer skrevs över.
   * ------------------------------------------------------------- */

  let harFyllt = false;

  async function fyllIFranVarukorg() {
    if (harFyllt) return;
    harFyllt = true;
    try {
      const varukorg = await hamtaKorg();
      const a = varukorg.attributes || {};

      if (a['Personnummer']) spegla(NYCKEL.pn, a['Personnummer']);
      if (a['Patient namn']) spegla(NYCKEL.namn, a['Patient namn']);
      if (a['Patient e-post']) spegla(NYCKEL.epost, a['Patient e-post']);
      if (a['Patient mobil']) spegla(NYCKEL.mobil, a['Patient mobil']);

      if (a['Provet avser'] === NAGON_ANNAN) {
        document
          .querySelectorAll('[name="' + NYCKEL.avser + '"][value="' + NAGON_ANNAN + '"]')
          .forEach((r) => { r.checked = true; });
      }
      synkaSynlighet();
      hanteraExpressknappar();
    } catch (e) {
      /* Varukorgen kunde inte läsas – fälten står kvar tomma, inget värre. */
    }
  }

  /* ---------------------------------------------------------------
   * 5. Validering av hela blocket
   * ------------------------------------------------------------- */

  function visaFel(text) {
    document.querySelectorAll('[data-fm-fel]').forEach((el) => {
      el.textContent = text || '';
      el.style.display = text ? 'block' : 'none';
    });
  }

  function synligt(el) {
    return !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  }

  function kontrollera(visa) {
    // Frågan står ovanför personnumret och kontrolleras därför först.
    if (!lasAvser()) {
      if (visa) {
        visaFel('Välj vem provet är till.');
        const r = alla(NYCKEL.avser).find(synligt);
        if (r) r.focus();
      }
      return false;
    }

    const pnRa = las(NYCKEL.pn);
    const tolkat = tolkaPersonnummer(pnRa);

    if (!tolkat.ok) {
      if (visa) {
        visaFel(tolkat.fel);
        const f = alla(NYCKEL.pn)[0];
        if (f) { f.setAttribute('aria-invalid', 'true'); f.focus(); }
      }
      return false;
    }

    // Skriv tillbaka det normaliserade numret så kunden ser vad vi sparar.
    spegla(NYCKEL.pn, tolkat.varde);
    alla(NYCKEL.pn).forEach((f) => f.removeAttribute('aria-invalid'));

    if (lasAvser() === NAGON_ANNAN) {
      const namn = las(NYCKEL.namn);
      if (namn.split(/\s+/).filter(Boolean).length < 2) {
        if (visa) visaFel('Ange för- och efternamn på den som ska testa sig.');
        return false;
      }
      if (INSTALLNINGAR.kravEpostTillAnnan && !giltigEpost(las(NYCKEL.epost))) {
        if (visa) visaFel('Ange e-postadress till den som ska testa sig. Dit skickar vi hälsodeklaration och provsvar.');
        return false;
      }
      const mobil = las(NYCKEL.mobil);
      if (INSTALLNINGAR.kravMobilTillAnnan && !giltigMobil(mobil)) {
        if (visa) visaFel('Ange mobilnummer till den som ska testa sig.');
        return false;
      }
      if (mobil && !giltigMobil(mobil)) {
        if (visa) visaFel('Kontrollera mobilnumret (t.ex. 070-123 45 67).');
        return false;
      }
    }

    if (visa) visaFel('');
    return true;
  }

  /* ---------------------------------------------------------------
   * 6. Spara till varukorgen – väntar in svaret innan vi går vidare
   * ------------------------------------------------------------- */

  function byggNot(befintlig, attribut) {
    // Ta bort rader vi själva lagt in tidigare, annars staplas de på varandra.
    const kvar = String(befintlig || '')
      .split('\n')
      .filter((rad) => !/^(Personnummer|Provet avser|Patient)\s*:/i.test(rad.trim()))
      .join('\n')
      .trim();

    const rader = [];
    if (attribut['Personnummer']) rader.push('Personnummer: ' + attribut['Personnummer']);
    if (attribut['Provet avser']) rader.push('Provet avser: ' + attribut['Provet avser']);
    if (attribut['Patient namn']) rader.push('Patient: ' + attribut['Patient namn']);
    if (attribut['Patient e-post']) rader.push('Patient e-post: ' + attribut['Patient e-post']);
    if (attribut['Patient mobil']) rader.push('Patient mobil: ' + attribut['Patient mobil']);

    return [kvar, rader.join('\n')].filter(Boolean).join('\n');
  }

  async function sparaTillVarukorg() {
    const tolkat = tolkaPersonnummer(las(NYCKEL.pn));
    if (!tolkat.ok) return false; // skriv aldrig över ett giltigt värde med skräp

    // Inget tyst "Mig själv" (1/10 2026). kontrollera() stoppar redan klicket
    // utan val; det här är skyddsnätet.
    const avser = lasAvser();
    if (!avser) return false;
    const annan = avser === NAGON_ANNAN;

    const attribut = {
      'Personnummer': tolkat.varde,
      'Provet avser': avser,
      'Patient namn': annan ? las(NYCKEL.namn) : '',
      'Patient e-post': annan ? las(NYCKEL.epost) : '',
      'Patient mobil': annan ? las(NYCKEL.mobil) : ''
    };

    let befintligNot = '';
    try {
      const svar = await fetch('/cart.js', { credentials: 'same-origin' });
      befintligNot = (await svar.json()).note || '';
    } catch (e) { /* fortsätt utan befintlig not */ }

    // Svarar Shopify med felstatus är attributen INTE sparade, och en order
    // utan Personnummer faller på golvet i FMX. Då hellre stanna i varukorgen.
    const svar = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attribut, note: byggNot(befintligNot, attribut) })
    });

    return svar.ok;
  }

  /* ---------------------------------------------------------------
   * 7. Stäng varje väg till kassan tills allt är ifyllt
   * ------------------------------------------------------------- */

  const KASSA_VALJARE = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href*="/checkout"]',
    '[data-checkout]'
  ].join(',');

  // Laddläge på kassaknappen: mellan klicket och kassan väntar vi in att
  // personnumret sparas till varukorgen, och utan synlig återkoppling såg
  // knappen död ut under tiden – då klickade folk flera gånger (Jennie 31/8).
  let kassaPagaende = false;

  function visaLaddlage(knapp) {
    kassaPagaende = true;
    knapp.setAttribute('data-fm-original', knapp.innerHTML);
    knapp.innerHTML = 'Ett ögonblick…';
    knapp.classList.add('fm-laddar');
    knapp.setAttribute('aria-busy', 'true');
    if ('disabled' in knapp) knapp.disabled = true;
  }

  function aterstallLaddlage(knapp) {
    kassaPagaende = false;
    const original = knapp.getAttribute('data-fm-original');
    if (original !== null) { knapp.innerHTML = original; knapp.removeAttribute('data-fm-original'); }
    knapp.classList.remove('fm-laddar');
    knapp.removeAttribute('aria-busy');
    if ('disabled' in knapp) knapp.disabled = false;
  }

  // Kommer kunden tillbaka från kassan via bakåtknappen kan sidan återställas
  // ur bfcache med knappen kvar i laddläge. Då väcker vi den igen.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-fm-original]').forEach(aterstallLaddlage);
  });

  document.addEventListener('click', async function (e) {
    const knapp = e.target.closest(KASSA_VALJARE);
    if (!knapp) return;

    // Finns inget personnummerfält på sidan har vi inget att vakta, och då ska
    // vi absolut inte lägga oss i. Säkerhetsventil så att inget köpflöde kan
    // låsas av den här filen.
    if (!alla(NYCKEL.pn).length) return;

    e.preventDefault();
    e.stopPropagation();

    // Första klicket jobbar redan – släpp inga fler förrän det är klart.
    if (kassaPagaende) return;

    if (!kontrollera(true)) return;

    visaLaddlage(knapp);

    let sparat = false;
    try { sparat = await sparaTillVarukorg(); } catch (fel) { sparat = false; }

    if (!sparat) {
      aterstallLaddlage(knapp);
      visaFel('Uppgifterna kunde inte sparas. Kontrollera uppkopplingen och försök igen.');
      return;
    }

    if (knapp.tagName === 'A') {
      window.location.href = knapp.getAttribute('href') || '/checkout';
      return;
    }

    // Skicka formuläret på riktigt så att eventuella antalsändringar följer med.
    // form.submit() går förbi vår submit-lyssnare, så ingen dubbelkontroll.
    // Knappen är disabled i laddläget, men det påverkar inte form.submit().
    const formId = knapp.getAttribute('form');
    const form = knapp.closest('form') || (formId ? document.getElementById(formId) : null);
    if (form) form.submit(); else window.location.href = '/checkout';
  }, { capture: true });

  // Skyddsnät om något ändå skickar varukorgsformuläret.
  //
  // VIKTIGT: matcha på att formuläret faktiskt innehåller personnummerfältet,
  // inte på formulärets action. Produktsidans "Lägg i varukorgen" postar till
  // /cart/add och matchar därmed en selektor som form[action*="/cart"]. Gör man
  // så blockeras varje köp innan det ens hamnat i varukorgen.
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || typeof form.querySelector !== 'function') return;
    if (!form.querySelector('[name="' + NYCKEL.pn + '"]')) return;
    if (!kontrollera(true)) { e.preventDefault(); e.stopPropagation(); }
  }, { capture: true });

  /* Express-/direktköpsknappar kan inte fångas med klick (de ligger i
     iframe hos Shopify), så de stängs av tills fälten är godkända. */
  function hanteraExpressknappar() {
    const iVarukorg = document.querySelector('.cart, #mini-cart, .mini-cart');

    // Varukorgar som bara innehåller samtal renderar inget personnummerfält
    // (villkoret ligger i main-cart.liquid). Då finns inget att fylla i, och
    // express-knapparna måste stå öppna. Samma säkerhetsventil som klick- och
    // submit-lyssnarna redan har: utan fält lägger vi oss inte i.
    const harPnFalt = alla(NYCKEL.pn).length > 0;
    const ok = harPnFalt ? kontrollera(false) : true;

    if (INSTALLNINGAR.blockeraExpressIVarukorgen && iVarukorg) {
      document
        .querySelectorAll('.additional-checkout-buttons, shopify-accelerated-checkout-cart')
        .forEach((el) => blockera(el, ok, 'Fyll i personnummer ovan för att betala med Shop Pay, Apple Pay eller Google Pay.'));
    }

    if (INSTALLNINGAR.blockeraDirektkopPaProduktsida) {
      document
        .querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout')
        .forEach((el) => {
          if (el.closest('.cart, #mini-cart, .mini-cart')) return; // hanterad ovan
          blockera(el, false, 'Lägg i varukorgen – där anger du personnummer för provet.');
        });
    }
  }

  function blockera(el, ok, text) {
    el.classList.toggle('fm-blockerad', !ok);
    let notis = el.nextElementSibling;
    const harNotis = notis && notis.classList && notis.classList.contains('fm-blockerad-notis');
    if (!ok && !harNotis) {
      notis = document.createElement('p');
      notis.className = 'fm-blockerad-notis';
      notis.textContent = text;
      el.parentNode.insertBefore(notis, el.nextSibling);
    } else if (ok && harNotis) {
      notis.remove();
    }
  }

  /* ---------------------------------------------------------------
   * 8. Håll allt i synk – varukorgssidan och lådan visar samma fält
   * ------------------------------------------------------------- */

  document.addEventListener('input', function (e) {
    const n = e.target.name;
    if (n === NYCKEL.pn || n === NYCKEL.namn || n === NYCKEL.epost || n === NYCKEL.mobil) {
      spegla(n, e.target.value);
      visaFel('');
      hanteraExpressknappar();
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.name === NYCKEL.avser) {
      speglaVal(e.target.value);
      synkaSynlighet();
      visaFel('');
      hanteraExpressknappar();
    }
  });

  // Normalisera personnumret när kunden lämnar fältet.
  document.addEventListener('blur', function (e) {
    if (e.target.name !== NYCKEL.pn) return;
    const t = tolkaPersonnummer(e.target.value);
    if (t.ok) { spegla(NYCKEL.pn, t.varde); visaFel(''); }
  }, true);

  document.addEventListener('cart:updated', function () { harFyllt = false; montera(); });
  document.addEventListener('DOMContentLoaded', function () { montera(); });

  // Varukorgslådan renderas om vid varje ändring i varukorgen, så fälten måste
  // monteras om. Observeraren är köad via requestAnimationFrame och montera()
  // är återinträdesskyddad – annars triggar den sina egna DOM-ändringar i all
  // oändlighet.
  // setTimeout och inte requestAnimationFrame: rAF pausas i flikar som ligger i
  // bakgrunden, och då monteras fälten aldrig om efter att lådan renderats om.
  let koad = false;
  new MutationObserver(function () {
    if (monterar || koad) return;
    koad = true;
    setTimeout(function () { koad = false; montera(); }, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState !== 'loading') montera();
})();


/**
*
* The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
* events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
* to easily extend the theme and re-use the theme infrastructure for your own code.
*
* The technical documentation is summarized here.
*
* ------------------------------------------------------------------------------------------------------------
* BEING NOTIFIED WHEN A VARIANT HAS CHANGED
* ------------------------------------------------------------------------------------------------------------
*
* This event is fired whenever a the user has changed the variant in a selector. The target get you the form
* that triggered this event.
*
* Example:
*
* document.addEventListener('variant:changed', function(event) {
*   let variant = event.detail.variant; // Gives you access to the whole variant details
*   let form = event.target;
* });
*
* ------------------------------------------------------------------------------------------------------------
* MANUALLY CHANGE A VARIANT
* ------------------------------------------------------------------------------------------------------------
*
* You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
* that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
* the variant ID.
*
* Example:
*
* const productVariantElement = document.querySelector('product-variants');
* productVariantElement.selectVariant(12345);
*
* ------------------------------------------------------------------------------------------------------------
* BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
* ------------------------------------------------------------------------------------------------------------
*
* This event is fired whenever a variant is added to the cart through a form selector (product page, quick
* view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
* please refer to the "cart:updated" event.
*
* Example:
*
* document.addEventListener('variant:added', function(event) {
*   var variant = event.detail.variant; // Get the variant that was added
* });
*
* ------------------------------------------------------------------------------------------------------------
* BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
* ------------------------------------------------------------------------------------------------------------
*
* This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
* has been removed, if the note has changed...). This event will also be emitted when a new variant has been
* added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
* this event will give you the complete details of the cart.
*
* Example:
*
* document.addEventListener('cart:updated', function(event) {
*   var cart = event.detail.cart; // Get the updated content of the cart
* });
*
* ------------------------------------------------------------------------------------------------------------
* REFRESH THE CART/MINI-CART
* ------------------------------------------------------------------------------------------------------------
*
* If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
* send the cart:refresh event, as shown below:
*
* document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
*   bubbles: true
* }));
*
* ------------------------------------------------------------------------------------------------------------
* USAGE OF CUSTOM ELEMENTS
* ------------------------------------------------------------------------------------------------------------
*
* Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
* by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
* number of custom elements, but the two most useful are drawer and popover. Each of those components add
* a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
* drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
* false to close it):
*
* document.getElementById('mini-cart').open = true;
*
* Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
* proper accessibility attributes...
*
* If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
* example:
*
* // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
* <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
*
* <drawer-content id="id-of-drawer">
*   Your content
* </drawer-content>
*
* The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
* is done automatically as soon as the element is inserted to the DOM.
*
* ------------------------------------------------------------------------------------------------------------
* THEME DEPENDENCIES
* ------------------------------------------------------------------------------------------------------------
*
* While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
* to power some of its features. Here is the list of all dependencies:
*
* "vendor.js":
*
* The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
*
* - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
* - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
* - instant-page (v5.1.0): https://github.com/instantpage/instant.page
* - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
* - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
*
* "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
* carousel on the page. Otherwise it is not loaded.
*
* "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
* feature is disabled, then this script is never loaded.
*/
